import type { SVGProps } from "react";
export interface GridDotsLeftIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function GridDotsLeftIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: GridDotsLeftIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M11.998 19.866a1.12 1.12 0 0 1 .736.282 1.12 1.12 0 0 1 .302 1.285 1.126 1.126 0 0 1-2.166-.439 1.125 1.125 0 0 1 1.128-1.128m8.997 0c.234 0 .451.073.631.195a1.124 1.124 0 0 1 .167 1.729 1.126 1.126 0 0 1-1.734-1.424c.055-.082.124-.153.199-.218a1.12 1.12 0 0 1 .737-.281Zm-13.493.003a1.126 1.126 0 0 1 0 2.25h-.006a1.125 1.125 0 0 1 0-2.25zm8.997 0a1.125 1.125 0 0 1 0 2.25h-.006a1.125 1.125 0 0 1 0-2.25zm-5.626-3.37v-.006a1.125 1.125 0 0 1 2.25 0v.006a1.125 1.125 0 0 1-2.25 0m8.997 0v-.006a1.126 1.126 0 0 1 2.25 0v.006a1.125 1.125 0 0 1-2.25 0m-7.872-5.63c.39 0 .732.199.934.5a1.12 1.12 0 0 1 .104 1.066 1.126 1.126 0 0 1-2.166-.438c0-.312.127-.594.332-.798.204-.204.485-.33.796-.33m8.997 0c.31 0 .591.127.795.33a1.12 1.12 0 0 1 .138 1.43 1.124 1.124 0 0 1-1.972-.194 1.12 1.12 0 0 1 .103-1.066c.201-.301.546-.5.936-.5m-13.493.003.114.006a1.126 1.126 0 0 1 0 2.239l-.114.005h-.006a1.125 1.125 0 0 1 0-2.25zm8.997 0 .114.006a1.125 1.125 0 0 1 0 2.239l-.114.005h-.006a1.125 1.125 0 0 1 0-2.25zm-5.626-3.37v-.006a1.125 1.125 0 0 1 2.25 0v.006a1.126 1.126 0 0 1-2.25 0m8.997 0v-.006a1.125 1.125 0 0 1 2.25 0v.006a1.125 1.125 0 0 1-2.25 0m-7.872-5.63c.234 0 .45.073.63.195a1.125 1.125 0 0 1 .407 1.373 1.1 1.1 0 0 1-.192.297 1.118 1.118 0 0 1-1.778-.105 1.12 1.12 0 0 1 .137-1.43c.204-.204.485-.33.796-.33m8.997 0c.31 0 .591.126.795.33a1.12 1.12 0 0 1 .138 1.43 1.125 1.125 0 0 1-1.562.303 1.1 1.1 0 0 1-.218-.198 1.12 1.12 0 0 1 .215-1.67c.18-.122.397-.195.632-.195m-13.493.003a1.126 1.126 0 0 1 0 2.25h-.006a1.125 1.125 0 0 1 0-2.25zm8.997 0a1.125 1.125 0 0 1 0 2.25h-.006a1.126 1.126 0 0 1 0-2.25zM1.875 21V3a1.125 1.125 0 0 1 2.25 0v18a1.125 1.125 0 0 1-2.25 0"
      />
    </svg>
  );
}
